import { Right } from "../enumerations/Right";

export class Permission {

	public static readonly $type: string = "Permission";
	public readonly $type: string = Permission.$type;

	public right: Right;
	public recordType?: string;
	public recordId?: number;

	constructor(right: Right, recordType: string, recordId?: number) {
		this.right = right;
		this.recordType = recordType;
		this.recordId = recordId;
	}
}
